// Health & Medical Disclosure — step-by-step wizard config.
// Field types: text, textarea, num, ynp (Yes/No/Prefer not to say), radio, checks, note.

const YNP = ['Yes', 'No', 'Prefer not to say'];

export const BODY_FRONT = 'https://static.prod-images.emergentagent.com/jobs/9cc27ad2-9473-4d8d-951e-838ca155566b/images/60cfcbd2900a5afb8bf2cb181877a1f6d6bb0bb5ce539424bd3cc81fa289fb52.jpeg';
export const BODY_BACK = 'https://static.prod-images.emergentagent.com/jobs/9cc27ad2-9473-4d8d-951e-838ca155566b/images/a8ecb13eb749a35f94e3679c30df1aefaf9c779b8ae533b21ed16514350fc33f.jpeg';

export const BODY_MARKERS = [
  { type: 'pain', label: 'Pain', symbol: 'X', color: '#c0392b' },
  { type: 'tightness', label: 'Tightness / restriction', symbol: 'O', color: '#8a6a5a' },
  { type: 'radiating', label: 'Radiating / travelling', symbol: '→', color: '#b8860b' },
  { type: 'numbness', label: 'Numbness / tingling', symbol: 'N', color: '#2f7d8c' },
  { type: 'weakness', label: 'Weakness', symbol: 'W', color: '#6a4c93' },
];

export const MEDICAL_STEPS = [
  {
    id: 'client-info', title: 'Client Information',
    fields: [
      { key: 'name', label: 'Full name', type: 'text' },
      { key: 'dob', label: 'Date of birth', type: 'text' },
      { key: 'phone', label: 'Phone', type: 'text' },
      { key: 'email', label: 'Email', type: 'text' },
      { key: 'occupation', label: 'Occupation', type: 'text' },
      { key: 'provider', label: 'Primary healthcare provider / physician (if applicable)', type: 'text' },
      { key: 'emergency_contact', label: 'Emergency contact', type: 'text' },
      { key: 'emergency_relationship', label: 'Relationship', type: 'text' },
      { key: 'emergency_phone', label: 'Emergency contact phone', type: 'text' },
    ],
  },
  {
    id: 'health-now', title: 'Your Health Right Now',
    fields: [
      { key: 'health_rating', label: 'How would you describe your current overall health?', type: 'radio', options: ['Excellent', 'Very Good', 'Good', 'Fair', 'Poor', 'Prefer not to say'] },
      { key: 'under_care', label: 'Currently under the care of a physician, specialist, physiotherapist or other healthcare professional?', type: 'ynp' },
      { key: 'under_care_detail', label: 'If yes, please describe (if relevant)', type: 'textarea' },
      { key: 'being_investigated', label: 'Currently being investigated, monitored or treated for a health concern?', type: 'ynp' },
      { key: 'being_investigated_detail', label: 'If yes, please describe', type: 'textarea' },
      { key: 'restrict_activity', label: 'Have you been advised to restrict or modify physical activity?', type: 'ynp' },
      { key: 'restrict_activity_detail', label: 'If yes, please describe', type: 'textarea' },
    ],
  },
  {
    id: 'heart', title: 'Medical History — Heart & Circulation',
    fields: [
      { key: 'heart_disease', label: 'Heart disease or heart condition', type: 'ynp' },
      { key: 'blood_pressure', label: 'High or low blood pressure', type: 'ynp' },
      { key: 'arrhythmia', label: 'Irregular heartbeat / arrhythmia', type: 'ynp' },
      { key: 'stroke_tia', label: 'Stroke or TIA', type: 'ynp' },
      { key: 'blood_clot', label: 'Blood clot / DVT / pulmonary embolism', type: 'ynp' },
      { key: 'circulation', label: 'Circulation or vascular problems', type: 'ynp' },
      { key: 'cardio_other', label: 'Other cardiovascular condition', type: 'text' },
    ],
  },
  {
    id: 'respiratory', title: 'Medical History — Respiratory',
    fields: [
      { key: 'asthma', label: 'Asthma', type: 'ynp' },
      { key: 'copd', label: 'COPD or chronic respiratory condition', type: 'ynp' },
      { key: 'shortness_breath', label: 'Unexplained or persistent shortness of breath', type: 'ynp' },
      { key: 'resp_other', label: 'Other respiratory condition', type: 'text' },
    ],
  },
  {
    id: 'neuro', title: 'Medical History — Neurological & Nervous System',
    fields: [
      { key: 'concussion', label: 'Concussion or traumatic brain injury', type: 'ynp' },
      { key: 'headaches', label: 'Frequent or severe headaches / migraines', type: 'ynp' },
      { key: 'dizziness', label: 'Dizziness, vertigo or balance difficulties', type: 'ynp' },
      { key: 'fainting', label: 'Fainting or unexplained loss of consciousness', type: 'ynp' },
      { key: 'seizure', label: 'Seizure disorder / epilepsy', type: 'ynp' },
      { key: 'numbness_hx', label: 'Numbness, tingling or altered sensation', type: 'ynp' },
      { key: 'weakness_hx', label: 'Weakness or unexplained loss of strength', type: 'ynp' },
      { key: 'neuro_condition', label: 'Neurological condition', type: 'ynp' },
      { key: 'neuro_detail', label: 'If yes or relevant, please explain', type: 'textarea' },
    ],
  },
  {
    id: 'msk', title: 'Medical History — Bones, Joints & Musculoskeletal',
    fields: [
      { key: 'arthritis', label: 'Arthritis', type: 'ynp' },
      { key: 'osteoporosis', label: 'Osteoporosis / osteopenia', type: 'ynp' },
      { key: 'disc_injury', label: 'Disc injury / herniation / degeneration', type: 'ynp' },
      { key: 'spinal_condition', label: 'Spinal condition', type: 'ynp' },
      { key: 'joint_injury', label: 'Joint injury or instability', type: 'ynp' },
      { key: 'fracture', label: 'Fracture or broken bone', type: 'ynp' },
      { key: 'joint_replacement', label: 'Joint replacement', type: 'ynp' },
      { key: 'tendon_injury', label: 'Tendon / ligament / muscle injury', type: 'ynp' },
      { key: 'chronic_pain', label: 'Chronic or recurring pain', type: 'ynp' },
      { key: 'msk_other', label: 'Other significant musculoskeletal condition', type: 'text' },
    ],
  },
  {
    id: 'metabolic', title: 'Medical History — Metabolic, Endocrine & Immune',
    fields: [
      { key: 'diabetes', label: 'Diabetes / blood sugar condition', type: 'ynp' },
      { key: 'thyroid', label: 'Thyroid condition', type: 'ynp' },
      { key: 'hormonal', label: 'Diagnosed hormonal / endocrine condition', type: 'ynp' },
      { key: 'autoimmune', label: 'Autoimmune condition', type: 'ynp' },
      { key: 'immune_disorder', label: 'Immune-system disorder', type: 'ynp' },
      { key: 'metabolic_other', label: 'Other', type: 'text' },
    ],
  },
  {
    id: 'digestive', title: 'Medical History — Digestive, Kidney & Liver',
    fields: [
      { key: 'gi_condition', label: 'Diagnosed gastrointestinal condition', type: 'ynp' },
      { key: 'ibd', label: "Inflammatory bowel disease / Crohn's / ulcerative colitis", type: 'ynp' },
      { key: 'kidney', label: 'Kidney disease or impaired kidney function', type: 'ynp' },
      { key: 'liver', label: 'Liver or gallbladder condition', type: 'ynp' },
      { key: 'digestive_other', label: 'Other', type: 'text' },
    ],
  },
  {
    id: 'cancer', title: 'Cancer & Significant Illness',
    fields: [
      { key: 'cancer_dx', label: 'Have you ever been diagnosed with cancer?', type: 'ynp' },
      { key: 'cancer_type', label: 'If comfortable — type', type: 'text' },
      { key: 'cancer_years', label: 'Approximate year(s)', type: 'text' },
      { key: 'cancer_treatment', label: 'Treatment included', type: 'checks', options: ['Surgery', 'Chemotherapy', 'Radiation', 'Immunotherapy', 'Hormonal therapy', 'Other', 'Prefer not to say'] },
      { key: 'cancer_current', label: 'Currently receiving treatment or ongoing medical monitoring?', type: 'ynp' },
      { key: 'significant_illness', label: 'Other significant illness, hospitalization or diagnosis (past or present)', type: 'textarea' },
    ],
  },
  {
    id: 'surgical', title: 'Surgical History',
    fields: [
      { key: 'had_surgery', label: 'Have you ever had surgery?', type: 'ynp' },
      { key: 'surgeries', label: 'Please list relevant surgeries (procedure · approx. date · area of body · anything I should know)', type: 'textarea' },
      { key: 'implants', label: 'Do you have any of the following?', type: 'checks', options: ['Surgical scars', 'Abdominal scars', 'Joint replacements', 'Plates / screws / pins', 'Spinal hardware', 'Implanted medical device', 'Pacemaker', 'Other implant', 'None', 'Prefer not to say'] },
      { key: 'implants_detail', label: 'Details', type: 'textarea' },
    ],
  },
  {
    id: 'accidents', title: 'Accidents & Injuries',
    fields: [
      { key: 'had_trauma', label: 'Significant accident, fall, sports injury, motor vehicle crash or other physical trauma?', type: 'ynp' },
      { key: 'trauma_what', label: 'If yes — what happened?', type: 'textarea' },
      { key: 'trauma_when', label: 'Approximately when?', type: 'text' },
      { key: 'trauma_areas', label: 'Areas affected', type: 'text' },
      { key: 'recovered', label: 'Do you feel completely recovered?', type: 'radio', options: ['Yes', 'No', 'Unsure', 'Prefer not to say'] },
      { key: 'previous_injuries', label: 'Previous injuries that still occasionally bother you', type: 'textarea' },
      { key: 'work_around', label: 'Anything you have learned to "work around" physically?', type: 'radio', options: ['Yes', 'No', 'Unsure'] },
      { key: 'work_around_detail', label: 'If yes, please describe', type: 'textarea' },
    ],
  },
  {
    id: 'pain', title: 'Current Pain & Discomfort',
    fields: [
      { key: 'pain_now', label: 'Are you currently experiencing pain or physical discomfort?', type: 'ynp' },
      { key: 'pain_primary', label: 'Primary area', type: 'text' },
      { key: 'pain_duration', label: 'How long has it been present?', type: 'text' },
      { key: 'pain_today', label: 'Pain / discomfort level today (0–10)', type: 'num' },
      { key: 'pain_worst', label: 'At its worst (0–10)', type: 'num' },
      { key: 'pain_desc', label: 'How would you describe it?', type: 'checks', options: ['Ache', 'Sharp', 'Burning', 'Tingling', 'Numbness', 'Throbbing', 'Shooting', 'Tightness', 'Stiffness', 'Weakness', 'Pressure', 'Other'] },
      { key: 'pain_pattern', label: 'Is it…', type: 'checks', options: ['Constant', 'Intermittent', 'Movement dependent', 'Worse after activity', 'Worse after sitting', 'Worse after standing', 'Worse at night', 'Worse in the morning', 'Unpredictable'] },
      { key: 'pain_worse', label: 'What makes it worse?', type: 'textarea' },
      { key: 'pain_better', label: 'What makes it feel better?', type: 'textarea' },
      { key: 'pain_radiate', label: 'Does the sensation travel or radiate anywhere?', type: 'radio', options: ['Yes', 'No', 'Unsure'] },
      { key: 'pain_radiate_detail', label: 'If yes, describe', type: 'text' },
    ],
  },
  {
    id: 'body-map', title: 'Body Map', type: 'bodymap',
    fields: [
      { key: 'body_map_notes', label: 'Additional notes', type: 'textarea' },
    ],
  },
  {
    id: 'medications', title: 'Medications',
    fields: [
      { key: 'rx_meds', label: 'Currently taking any prescription medications?', type: 'ynp' },
      { key: 'otc_meds', label: 'Taking any over-the-counter medications regularly?', type: 'ynp' },
      { key: 'meds_affect', label: 'Any medication that may affect your response to exercise/movement (blood pressure, heart rate, blood sugar, balance, pain perception, alertness, clotting, hydration)?', type: 'radio', options: ['Yes', 'No', 'Unsure', 'Prefer not to say'] },
      { key: 'meds_detail', label: 'If comfortable — medication · reason/condition · anything relevant to participation', type: 'textarea' },
    ],
  },
  {
    id: 'allergies', title: 'Allergies & Medical Precautions',
    fields: [
      { key: 'allergies', label: 'Do you have any significant allergies?', type: 'ynp' },
      { key: 'allergies_detail', label: 'If yes, please describe', type: 'text' },
      { key: 'epipen', label: 'Do you carry an EpiPen or other emergency medication?', type: 'radio', options: ['Yes', 'No', 'N/A', 'Prefer not to say'] },
      { key: 'emergency_condition', label: 'Any condition that could require emergency medication or specific assistance?', type: 'ynp' },
      { key: 'emergency_detail', label: 'If yes, what would be helpful for me to know?', type: 'textarea' },
    ],
  },
  {
    id: 'reproductive', title: "Women's / Reproductive Health",
    note: 'Complete only if relevant and if you are comfortable doing so.',
    fields: [
      { key: 'pregnant', label: 'Are you currently pregnant?', type: 'radio', options: ['Yes', 'No', 'Unsure', 'N/A', 'Prefer not to say'] },
      { key: 'recent_birth', label: 'Have you given birth within the past 12 months?', type: 'radio', options: ['Yes', 'No', 'N/A', 'Prefer not to say'] },
      { key: 'pelvic_surgery', label: 'Significant pelvic or abdominal surgery?', type: 'ynp' },
      { key: 'reproductive_surgery', label: 'Hysterectomy or other reproductive surgery that may be relevant?', type: 'ynp' },
      { key: 'reproductive_notes', label: 'Anything about pelvic health, pregnancy, postpartum, menopause or reproductive health to know?', type: 'textarea' },
    ],
  },
  {
    id: 'other', title: 'Other Important Medical Information',
    fields: [
      { key: 'other_important', label: 'Anything about your body or medical history you feel is important for me to know?', type: 'textarea' },
      { key: 'concerned_physically', label: 'Anything you are concerned I may ask you to do physically?', type: 'textarea' },
      { key: 'no_touch', label: 'Is there an area of your body you do not want touched or manually cued?', type: 'radio', options: ['Yes', 'No'] },
      { key: 'no_touch_detail', label: 'If yes, please describe', type: 'text' },
      { key: 'comfort_notes', label: 'Anything else that would help you feel safe and comfortable during sessions?', type: 'textarea' },
    ],
  },
];

export const DECLARATION = [
  'I understand that the purpose of this form is to provide relevant health and medical information that may help guide safe participation in movement, training and wellness services.',
  'I understand that completing this form does not constitute a medical assessment or diagnosis.',
  'I confirm that the information I have chosen to provide is accurate to the best of my knowledge.',
  'I understand that I am responsible for informing Grounded Wellness with Jill of significant changes to my health, medical status, medication, injury or physical condition that may affect my participation.',
  'I understand that I may be advised to consult an appropriate healthcare professional before beginning or continuing certain activities when circumstances indicate that further assessment or medical guidance would be appropriate.',
];

// itemId -> label lookup for PDF / display
export const MEDICAL_LABELS = MEDICAL_STEPS.reduce((acc, s) => {
  s.fields.forEach((f) => { acc[f.key] = f.label; });
  return acc;
}, {});
